import React, { useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Tabs } from 'antd';
import './index.less';

const { TabPane } = Tabs;
const data = [
  {
    title: '会场运营',
    content: '查看活动关联会场，全面掌握会场信息',
  },
  {
    title: '氛围打标',
    content: '给活动商品打上商详、搜索等位置的统一标签，营造活动氛围',
  },
  {
    title: '活动选品',
    content: '对活动商品进行统一的收集、管理，提升活动运营效率',
  },
  {
    title: '综合促销',
    content: '在主题活动下玩转促销、优惠券、打标、膨胀金活动。',
  },
];

export default function ActivityControlIntro(props) {
  const [status, setStatus] = useState(props.introType);
  const [introData, setIntroData] = useState(data[props.introType]);

  // 更新显示的tab以及文案
  function callback(key) {
    setIntroData(data[key]);
    setStatus(key);
  }

  return (
    <div className="activity-control-intro-wrapper">
      <div className="activity-control-intro-item">
        <div className="activity-control-intro-title">{introData.title}</div>
        <div className="activity-control-intro-content">{introData.content}</div>
        <div className="activity-control-intro-close" onClick={props.onClose}>
          <CloseOutlined className="activity-control-intro-close-item" />
        </div>
        <div className="activity-control-intro-background" />
        {/* <div className='activity-control-intro-label' /> */}
        <div className="activity-control-intro-tabs">
          <Tabs onChange={callback} activeKey={status.toString()}>
            {/* <TabPane tab='入口资源申请' key='0'> */}
            {/*  <div className='activity-control-intro-tabs-item'> */}
            {/*    <div className='activity-control-intro-apply' /> */}
            {/*  </div> */}
            {/* </TabPane> */}
            <TabPane tab="会场运营" key="0">
              <div className="activity-control-intro-tabs-item">
                <div className="activity-control-intro-venue" />
              </div>
            </TabPane>
            <TabPane tab="氛围打标" key="1">
              <div className="activity-control-intro-tabs-item">
                <div className="activity-control-intro-env" />
              </div>
            </TabPane>
            <TabPane tab="活动选品" key="2">
              <div className="activity-control-intro-tabs-item">
                <div className="activity-control-intro-choose" />
              </div>
            </TabPane>
            <TabPane tab="综合促销" key="3">
              <div className="activity-control-intro-tabs-item">
                <div className="activity-control-intro-zongcu" />
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
